import {
  Component,
  ComponentRef,
  EventEmitter,
  Inject,
  Input, OnChanges,
  OnInit,
  Output, PLATFORM_ID,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {RichTextEditorComponent} from "../rich-text-editor/rich-text-editor.component";

@Component({
  selector: 'app-rich-text-editor-wrapper',
  templateUrl: './rich-text-editor-wrapper.component.html',
  styleUrl: './rich-text-editor-wrapper.component.scss'
})
export class RichTextEditorWrapperComponent implements OnInit, OnChanges {
  @ViewChild("container", {read: ViewContainerRef}) container?: ViewContainerRef;

  @Input() content: string | undefined;
  @Input() disabled: boolean = false;
  @Output() contentChange: EventEmitter<string | undefined> = new EventEmitter<string | undefined>();

  private componentInstance?: RichTextEditorComponent;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      import("../rich-text-editor/rich-text-editor.component").then(({RichTextEditorComponent}) => {
        const componentRef: ComponentRef<RichTextEditorComponent> = this.container!.createComponent(RichTextEditorComponent);
        this.componentInstance = componentRef.instance;
        this.componentInstance.content = this.content;
        this.componentInstance.disabled = this.disabled;
        this.componentInstance.contentChange = this.contentChange;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId) && this.componentInstance) {
      this.componentInstance.content = this.content;
      this.componentInstance.disabled = this.disabled;
      this.componentInstance.contentChange = this.contentChange;
      this.componentInstance.ngOnChanges(changes);
    }
  }
}
